import { render, staticRenderFns } from "./CarouselModal.vue?vue&type=template&id=eab1b630&"
import script from "./CarouselModal.vue?vue&type=script&lang=js&"
export * from "./CarouselModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports